import {ENDPOINTS} from "../common/endpoints";
import {GuidLightDto} from '../models/common/IGuidLight';
import {DecorationGuidDto, DecorationGuidListParams, DecorationGuidListResponse, SaveDecorationGuidRequest} from '../models/Decorations/IDecorationGuid';
import {baseAPI} from "./BaseAPI";
import {TAGS} from "./TagTypes";

export const decorationAPI = baseAPI.injectEndpoints({
    endpoints: (build) => ({
        getDecorationsV2: build.query<DecorationGuidListResponse, DecorationGuidListParams>({
            query: params => ({url: ENDPOINTS.DECORATIONS.V2, method: 'GET', params}),
            providesTags: [TAGS.DECORATIONS],
        }),
        getDecorationsForOrderV2: build.query<DecorationGuidDto[], void>({
            query: () => ({url: ENDPOINTS.DECORATIONS.V2_ALL_LIGHT, method: 'GET'}),
            providesTags: [TAGS.DECORATIONS_FOR_ORDER],
        }),
        getDecorationV2: build.query<DecorationGuidDto, string>({
            query: id => ({url: `${ENDPOINTS.DECORATIONS.V2}/${id}`, method: 'GET'}),
            providesTags: (_result, _error, id) => [{type: TAGS.DECORATION, id}],
        }),
        getDecorationsV2AllLight: build.query<GuidLightDto[], void>({
            query: () => ({url: ENDPOINTS.DECORATIONS.V2_ALL_LIGHT, method: 'GET'}),
            providesTags: [TAGS.DECORATIONS_FOR_ORDER],
        }),
        createDecorationV2: build.mutation<DecorationGuidDto, SaveDecorationGuidRequest>({
            query: body => ({url: ENDPOINTS.DECORATIONS.V2, method: 'POST', body}),
            invalidatesTags: [TAGS.DECORATIONS, TAGS.DECORATIONS_FOR_ORDER],
        }),
        updateDecorationV2: build.mutation<DecorationGuidDto, {id: string; body: SaveDecorationGuidRequest}>({
            query: ({id, body}) => ({url: `${ENDPOINTS.DECORATIONS.V2}/${id}`, method: 'PUT', body}),
            invalidatesTags: (_result, _error, {id}) => [TAGS.DECORATIONS, TAGS.DECORATIONS_FOR_ORDER, {type: TAGS.DECORATION, id}],
        }),
        deleteDecorationV2: build.mutation<void, string>({
            query: id => ({url: `${ENDPOINTS.DECORATIONS.V2}/${id}`, method: 'DELETE'}),
            invalidatesTags: [TAGS.DECORATIONS, TAGS.DECORATIONS_FOR_ORDER],
        }),
    })
})
